//hendleri za user inpute
import oibValidation from "../oibValidation/oibValidation";

export const handleUserInput = (e, objectData) => {
  const value = e.target.value;
  // const id = e.target.id;
  const { name } = e.target;
  let oibValidated;
  let userInput;

  //ako je oib, setstate POSEBNO ZA OIB!
  // if (id === "oib") {
  if (name === "oib") {
    oibValidated = oibValidation(value);
    userInput = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.group]: {
          ...prevState.newFormData[objectData.group],
          oibValidated,
          [name]: e.target.value.toString(),
        },
      },
    });
    return userInput;
  }

  userInput = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.group]: {
        ...prevState.newFormData[objectData.group],
        [name]: e.target.value.toString(),
      },
    },
  });
  return userInput;
};

export const handleMappedUserInput = (e, objectData) => {
  const value = e.target.value;
  // const id = e.target.id;
  const { name } = e.target;
  let oibValidated;
  let userInput;
  if (name === "oibDrustva" || name === "oib") {
    oibValidated = oibValidation(value);
    userInput = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.group]: [
          ...prevState.newFormData[objectData.group].map((element) =>
            element.id === objectData.id
              ? {
                  ...element,
                  oibValidated,
                  [name]: e.target.value.toString(),
                  // dataFetched: false,
                }
              : element
          ),
        ],
      },
    });
    return userInput;
  }

  userInput = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.group]: [
        ...prevState.newFormData[objectData.group].map((element) =>
          element.id === objectData.id
            ? {
                ...element,
                [name]: e.target.value.toString(),
              }
            : element
        ),
      ],
    },
  });
  return userInput;
};
